import { Component, Input, OnInit, OnChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ProdutoCatalogoService } from './produto-catalogo.service';
import { IMultiSelectSettings, IMultiSelectTexts, MultiselectDropdownComponent } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { Util } from '../../../shared/utils/util';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { MessageService } from '../../messages/message.service';
import { CpfCnpjPipe } from '../../pipes/cpf-cnpj.mask.pipe';
import Swal from 'sweetalert2';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'produto-catalogo',
    templateUrl: './produto-catalogo.component.html',
    styleUrls: ['./produto-catalogo.component.scss'],
    providers: [ProdutoCatalogoService]
})
export class ProdutoCatalogoComponent implements OnInit, OnChanges {
    @ViewChild('selectProdutos', { static: false }) private selectProdutos: MultiselectDropdownComponent;
    @Input() catalogo: any;

    idCatalogo = null;
    listaProdutoFiltro = [];
    listaProdutoFiltroOriginal = [];
    listaTipoEmissao = [];

    // Forms
    @Input() mainForm: FormGroup;
    formFiltro: FormGroup;

    // Mensagens de validações
    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();
    MSG_CAMPO_INVALIDO = Util.getMensagemCampoInvalido();
    MSG_CAMPO_CARACTERESESPECIAIS = Util.getMensagemCampoCaracteresEspeciais();

    public controlsSettings: IMultiSelectSettings = {
        enableSearch: true,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-secondary btn-block',
        displayAllSelectedText: true,
        dynamicTitleMaxItems: 0,
        showCheckAll: true,
        autoUnselect: true,
        showUncheckAll: true
    };

    constructor(
        private formBuilder: FormBuilder,
        private produtoCatalogoService: ProdutoCatalogoService,
        private toastr: ToastrService,
        private router: Router,
        private messageService: MessageService,
        private cpfCnpjPipe: CpfCnpjPipe
    ) { }

    ngOnInit() {
        this.idCatalogo = this.catalogo.idCatalogo;
        this.createForm();
        this.populaDropTipoEmissao();
        this.search();
        this.validateInputs();
    }

    ngOnChanges() {

        if (this.mainForm) {
            this.mainForm.get('apenasProdutosAtivos').valueChanges.subscribe(x => {
                this.search();
            });
        }
    }

    public getConfigSelectTexts(title: string) {
        const controlsText: IMultiSelectTexts = {
            checkAll: 'Marcar todos',
            uncheckAll: 'Desmarcar todos',
            checked: 'Item selecionado',
            checkedPlural: 'Itens selecionados',
            searchPlaceholder: 'Procurar',
            defaultTitle: title,
            allSelected: 'Todos os itens selecionados.',
            searchEmptyResult: 'Nada encontrado...',
            searchNoRenderText: 'Digite para ver resultados...',
        };

        return controlsText;
    }

    private search() {
        this.removerTodosElementosFormArray(this.listaProdutos);
        this.produtoCatalogoService.getList(this.idCatalogo).subscribe(result => {
            if (result) {

                if (this.mainForm.get('apenasProdutosAtivos').value) {
                    result = result.filter(x => x.Ativo === true);
                }

                result.forEach(item => {
                    const group = this.initDefaultProduct();
                    this.setFormProductValues(group, item, 1);
                    this.listaProdutos.push(group);
                });
            }
        });
    }

    private removerTodosElementosFormArray(formArray: FormArray){
        while (formArray.length !== 0) {
          formArray.removeAt(0);
        }
        this.mainForm.markAsPristine();
    }

    private successNavigationEnd() {
        this.mainForm.markAsPristine();
        this.onCancel();
    }

    private setFormProductValues(group, item, operation) {
        // operation -> 1 get list / 2 add
        const values = group.getRawValue();
        values.idCatalogoProduto = item.idCatalogoProduto ? item.idCatalogoProduto : 0;
        values.idCatalogo = this.idCatalogo;
        values.idEntidadeProduto = item.idEntidadeProduto;
        values.idTipoEmissao = item.idTipoEmissao;
        values.TipoEmissao = item.TipoEmissao;
        values.ProdutoModelo = item.ProdutoModelo;
        values.ProdutoTipo = item.ProdutoTipo;
        values.ProdutoValidade = item.ProdutoValidade;
        values.MidiaTipo = item.MidiaTipo ? item.MidiaTipo : 'Sem Mídia';
        values.DiasPeriodoUso = item.DiasPeriodoUso ? `${item.DiasPeriodoUso} dias` : 'Não definido';

        if (operation === 1) {
            values.Nome = item.Nome;
            values.EntidadeProdutoNome = item.EntidadeProdutoNome;
            values.Ativo = item.Ativo;
            values.Codigo = item.Codigo;
        } else {
            values.Nome = item.Nome;
            values.EntidadeProdutoNome = item.Nome;
            values.Ativo = true;
        }

       
        values.ValorMinimo = item.ValorMinimo ? item.ValorMinimo : 0;
        values.ValorMaximo = item.ValorMaximo ? item.ValorMaximo : 0;
        values.Valor = item.Valor ? item.Valor : values.ValorMinimo;
        values.DescricaoValorMinMax = `O valor deve estar entre ${item.ValorMinimo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} e ${item.ValorMaximo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
        values.DescricaoEntidadeProdutoNome = `Nome original: ${values.EntidadeProdutoNome}`;
        group.patchValue(values);
    }

    private initDefaultProduct() {
        return new FormGroup({
            idCatalogoProduto: new FormControl(null),
            idCatalogo: new FormControl(null),
            idEntidadeProduto: new FormControl(null),
            idTipoEmissao: new FormControl(null),
            TipoEmissao: new FormControl(null),
            ProdutoModelo: new FormControl(null),
            ProdutoTipo: new FormControl(null),
            ProdutoValidade: new FormControl(null),
            MidiaTipo: new FormControl(null),
            Nome: new FormControl(null, [Validators.required]),
            EntidadeProdutoNome: new FormControl(null),
            Codigo: new FormControl(null, [Validators.required]),
            Ativo: new FormControl(null, [Validators.required]),
            Valor: new FormControl(null, [Validators.required]),
            ValorMinimo: new FormControl(null),
            ValorMaximo: new FormControl(null),
            DiasPeriodoUso: new FormControl(null),
            DescricaoValorMinMax: new FormControl(null),
            DescricaoEntidadeProdutoNome: new FormControl(null)
        });
    }
    
    private createForm() {
        const nomeParceiro = `${this.catalogo.Parceiro.Nome} (${this.cpfCnpjPipe.transform(this.catalogo.Parceiro.CNPJ)})`;
        
        this.formFiltro = this.formBuilder.group({
            idTipoEmissao: [-1],
            idsEntidadeProduto: [null],
            Parceiro: [{ value: nomeParceiro, disabled: true }],
            Catalogo: [{ value: this.catalogo.Nome, disabled: true }]
        });
    }

    public onCancel() {
        this.router.navigate(['/pages/parceiros/catalogo']);
    }

    public onSave() {
        if (this.listaProdutos.length === 0) {
            this.messageService.handleMessage({
                title: 'Atenção!',
                text: 'Você precisa adicionar produtos para salvar. ;)',
                 icon: 'warning'
            });
        } else if (this.mainForm.valid) {
            Swal.fire({
                title: 'Tem certeza?',
                text: 'Deseja salvar os dados editados?',
                icon: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, atualizar!',
                cancelButtonText: 'Não, continuar editando!',
                //confirmButtonClass: 'btn btn-success',
                //cancelButtonClass: 'btn btn-danger',
            }).then((result) => {
                if (result.value) {
                    this.add();
                }
            });
        } else {
            this.messageService.handleMessage({
                title: 'Atenção!',
                text: 'Você precisa preencher todos os campos obrigatórios para salvar. ;)',
                 icon: 'warning'
            });
        }
    }

    private add() {
        this.produtoCatalogoService.add(this.listaProdutos.getRawValue())
            .subscribe(retorno => {
                if (retorno) {
                    this.messageService.handleMessage({
                        title: 'Atualizado ;)',
                        text: 'Os produtos do catálogo foram atualizados com sucesso',
                        icon: 'success'
                    });

                    this.successNavigationEnd();
                } else {
                    this.messageService.handleMessage({
                        title: 'Oops ;(',
                        text: 'Ocorreu um erro ao atualizar os produtos do catálogo',
                         icon: 'error'
                    });
                }
            });
    }

    get listaProdutos() {
        return this.mainForm.get('listaProdutos') as FormArray;
    }

    private populaDropTipoEmissao() {
        this.produtoCatalogoService.getListTipoEmissao().subscribe(result => {
            this.listaTipoEmissao = result;
        });
    }

    private groupProductsFilter() {
        let listaAux = [{
            id: null,
            name: null,
            Validade: null,
            Midia: null,
            Filhos: [],
        }];

        this.listaProdutoFiltroOriginal.forEach(item => {
            const existente = listaAux.find(x => x.Validade === item.Validade &&
                x.Midia === item.Midia);

            if (!existente) {
                item.MidiaTipo = item.MidiaTipo ? item.MidiaTipo : 'Sem Mídia';
                const name = `Validade de ${item.ProdutoValidade}, Mídia: ${item.MidiaTipo}`;

                const parentId = listaAux.length * -1;

                listaAux.push(
                    {
                        id: parentId,
                        name: name,
                        Validade: item.Validade,
                        Midia: item.Midia,
                        Filhos: [item],
                    });
            } else {
                existente.Filhos.push(item);
            }
        });

        listaAux = listaAux.slice(1);

        listaAux.forEach(pai => {
            this.listaProdutoFiltro.push(
                {
                    id: pai.id,
                    name: pai.name,
                    isLabel: true,
                });

            pai.Filhos.forEach(filho => {
                let name = `${filho.Nome} (Tipo: ${filho.ProdutoTipo}, Modelo: ${filho.ProdutoModelo}`;

                if (filho.DiasPeriodoUso) {
                    name += `, Período de Uso:  ${filho.DiasPeriodoUso} dias)`;
                } else {
                    name += `)`;
                }

                this.listaProdutoFiltro.push(
                    {
                        id: filho.idEntidadeProduto,
                        name: name,
                        parentId: pai.id
                    });
            });
        });
    }

    private populaDropProduto(val) {
        this.produtoCatalogoService.getListProducts(val, this.idCatalogo).subscribe(result => {
            this.listaProdutoFiltro = [];
            this.listaProdutoFiltroOriginal = [];

            if (result) {
                const idsCadastrados = this.listaProdutos.getRawValue().map(x => x.idEntidadeProduto);
                this.listaProdutoFiltroOriginal = result.filter(i => !idsCadastrados.includes(i.idEntidadeProduto));
                this.groupProductsFilter();
            }

            this.selectProdutos.uncheckAll();
        });
    }

    public onCheckboxChange(val) {
        const tipoEmissaoChecked = this.formFiltro.get('idTipoEmissao').value;
        if(tipoEmissaoChecked > 0)
            this.populaDropProduto(tipoEmissaoChecked)
    }

    public onChangeTipoEmissao(val) {
        if (val > 0) {
            this.populaDropProduto(val);
        } else {
            this.listaProdutoFiltro = [];
            this.listaProdutoFiltroOriginal = [];
        }
    }

    public addProduct() {
        if (Number(this.formFiltro.get('idsEntidadeProduto').value) === 0 ||
            this.formFiltro.get('idTipoEmissao').value === -1) {
            this.toastr.warning('Selecione o Tipo de Emissão e o Produto para adicionar na lista', 'Atenção!');
            return;
        }

        this.mainForm.markAsDirty();

        const listaSelecionada = this.formFiltro.get('idsEntidadeProduto').value;

        listaSelecionada.forEach((items) => {
            const produtoSelecionado = this.listaProdutoFiltroOriginal.find(x => x.idProduto === items);

            if (produtoSelecionado) {
                const group = this.initDefaultProduct();
                this.setFormProductValues(group, produtoSelecionado, 2);
                this.listaProdutos.insert(0, group);

            }
        });

        this.listaProdutoFiltro = this.listaProdutoFiltro.filter(i => !listaSelecionada.includes(i.id));
        this.selectProdutos.uncheckAll();
    }

    public removerProduto(i) {
        Swal.fire({
            title: 'Tem certeza?',
            text: 'Deseja realmente remover o produto do catálogo?',
            icon: 'warning',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Não, cancelar!',
           // confirmButtonClass: 'btn btn-success',
           // cancelButtonClass: 'btn btn-danger',
        }).then((result) => {
            if (result.value) {
                this.listaProdutos.removeAt(i);
                this.populaDropProduto(this.formFiltro.get('idTipoEmissao').value);
            }
        });
    }

    public onChangeProductValue(form) {
        const item = form.getRawValue();

        if (item.Valor > item.ValorMaximo) {
            item.Valor = item.ValorMaximo;
            form.patchValue(item);
            this.toastr.warning('O Valor informado não está dentro dos limites definidos.', 'Atenção!');
        } else if (item.Valor < item.ValorMinimo) {
            item.Valor = item.ValorMinimo;
            form.patchValue(item);
            this.toastr.warning('O Valor informado não está dentro dos limites definidos.', 'Atenção!');
        }
    }

    public validateInputs() {
        const control = this.mainForm.get('listaProdutos') as FormArray;
        let hasError = false;

        control.controls.forEach(control => {
            if (!control.get('Valor').value ||
                control.get('Valor').value <= 0 || !control.get('Nome').value ||
                control.get('Nome').value <= 0) {
                hasError = true;
            }
        });

        if (hasError) {
            this.toastr.warning('Você precisa informar todos campos para continuar', 'Campos inválidos!');
            return;
        }
    }
}
